<template>
  <component :is="perfilData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="perfilData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'perfils'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>
    <b-col class="mb-4">
      <div class="demo-inline-spacing">
        <b-button
            class="mr-2 bg-secondary bg-darken-2 border-0"
            @click="voltar"
        >
          <feather-icon icon="ArrowLeftCircleIcon" size="18"/>
          Voltar
        </b-button>
      </div>
    </b-col>
    <div><b-tabs
        v-if="perfilData"
        pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
              icon="UserIcon"
              size="16"
              class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Informações</span>
        </template>
        <PerfilAcessoEditTabAccount
            :perfilData="perfilData"
            :permissao="permissao"
            class="mt-2 pt-75"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon
              icon="UserIcon"
              size="16"
              class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Permissões</span>
        </template>

        <PerfilAcessoEditPermission
            :perfilData="perfilData"
            :allPermissoes="todasPermissoes"
            class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs></div>

  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BCol, BButton,
} from 'bootstrap-vue';
import { ref, onUnmounted, onBeforeMount } from '@vue/composition-api';
import router from '@/router';
import store from '@/store';
import Notifier from '@/libs/Notifier';
import usePermissaoList from '@/views/app/permissao/permissao-list/usePermissaoList';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import userStoreModule from '../perfilAcessoStoreModule';
import PerfilAcessoEditTabAccount from './PerfilAcessoEditTabAccount.vue';
import PerfilAcessoEditPermission from './PerfilAcessoEditPermission.vue';

export default {
  components: {
    BButton,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    PerfilAcessoEditPermission,
    PerfilAcessoEditTabAccount,
  },

  methods: {
    voltar() {
      router.push({ name: 'perfils' });
    },
  },
  setup() {
    const perfilData = ref(null);
    const permissao = ref(null);
    const permissoes = ref([]);
    const todasPermissoes = ref([]);

    const USER_APP_STORE_MODULE_NAME = 'app-perfilAcesso';

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const fetchPerfilAcesso = () => store.dispatch('app-perfilAcesso/fetchPerfilAcesso', { id: router.currentRoute.params.id })
      .then((response) => {
        perfilData.value = response.data.data;
        permissao.value = response.data.Permissoes;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          perfilData.value = undefined;
          permissao.value = undefined;
        }
      });
    const fetchPermissoes = () => store.dispatch('app-perfilAcesso/fetchPermissoes')
      .then((response) => {
        const { data } = response.data;
        todasPermissoes.value = data.map((item) => {
          const found = permissao.value.find((perm) => perm.id_permissao === item.id);
          if (found) {
            return {
              ...item,
              status: true,
            };
          }
          return {
            ...item,
            status: false,
          };
        });
        callback(data);
      })
      .catch(() => {

      });
    onBeforeMount(() => {
      fetchPerfilAcesso()
        .then(() => fetchPermissoes())
        .catch((error) => {
          console.error('Erro durante a execução das operações de busca de dados:', error);
        });
    });

    return {
      permissoes,
      perfilData,
      permissao,
      todasPermissoes,
    };
  },
};
</script>

<style>

</style>
